import { render } from "./PatientIndicatorsReadingView.vue?vue&type=template&id=0bbaa963&scoped=true"
import script from "./PatientIndicatorsReadingView.vue?vue&type=script&lang=js"
export * from "./PatientIndicatorsReadingView.vue?vue&type=script&lang=js"

import "./PatientIndicatorsReadingView.vue?vue&type=style&index=0&id=0bbaa963&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbaa963"]])

export default __exports__